import { store } from "../../store.js"
import axios from "../../plugins/axios.js"

export const checkPrivilege = function(need, has = store.state.$privilege.privileges) {
    if (!has) return false;
    for (let item in need) {
        if (!has[item] || has[item] < need[item]) return false;
    }
    return true;
}

export const pages = [
    {
        path: '/auditUpdate',
        name: 'auditUpdate',
        meta: {
            title: '自助更新审核',
            privilege: { tower: 1 },
            icon: "audit",
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "auditUpdate" */ './panels/AuditUpdate.vue')
    },
    {
        path: '/addTower',
        name: 'addTower',
        meta: {
            title: '发塔',
            privilege: { tower: 2 },
            icon: "upload",
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "addTower" */ './panels/AddTower.vue')
    },
    {
        path: '/modifyTower/:id?',
        name: 'modifyTower',
        meta: {
            title: '管理塔',
            privilege: { tower: 3 },
            icon: "edit",
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "modifyTower" */ './panels/ModifyTower.vue')
    },
];

store.registerModule('$privilege', {
    namespaced: true,
    state: {
        privileges: {},
        pages,
        notAdmin: false
    },
    getters: {
        pages(state) {
            return state.pages.filter((e) => checkPrivilege(e.privilege, state.privileges));
        }
    },
    mutations: {
        setUserPrivilege(state, privileges) {
            state.privileges = privileges;
            if (!privileges) state.notAdmin = true;
        }
    },
    actions: {
        async fetch({ commit }) {
            const { data } = await axios.get("/backend/admin/userPrivilege.php");
            if (data.code == 0) {
                commit("setUserPrivilege", data.privileges);
            } else {
                commit("setUserPrivilege", null);
            }
        }
    }
})
